(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hg-hologram"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      root.querySelectorAll('[data-hg-hologram]:not([data-hg-ready])').forEach(function (object) {
        object.dataset.hgReady = 'true';
        if (!('IntersectionObserver' in window)) { object.classList.add('is-visible'); return; }
        const observer = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { object.classList.toggle('is-visible', entry.isIntersecting); }); }, { threshold: .05 });
        observer.observe(object);
        document.addEventListener('visibilitychange', function () { if (document.hidden) object.classList.remove('is-visible'); else { const rect = object.getBoundingClientRect(); object.classList.toggle('is-visible', rect.bottom > 0 && rect.top < window.innerHeight); } });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
